const jurisdictionCoordinates = {
    "Buenos Aires": { lat: -36.8927, lon: -60.3225 },
    "Catamarca": { lat: -28.4696, lon: -65.7852 },
    "Chaco": { lat: -27.4515, lon: -58.9866 },
    "Chubut": { lat: -43.3007, lon: -65.1025 },
    "Ciudad Autónoma de Buenos Aires": { lat: -34.6083, lon: -58.3712 },
    "Córdoba": { lat: -31.4201, lon: -64.1888 },
    "Corrientes": { lat: -27.4695, lon: -58.8306 },
    "Entre Ríos": { lat: -32.4825, lon: -58.2366 },
    "Formosa": { lat: -26.1775, lon: -58.1781 },
    "Jujuy": { lat: -24.1858, lon: -65.2995 },
    "La Pampa": { lat: -36.6206, lon: -64.2836 },
    "La Rioja": { lat: -29.4111, lon: -66.8507 },
    "Mendoza": { lat: -32.8895, lon: -68.8458 },
    "Misiones": { lat: -27.3628, lon: -55.9001 },
    "Neuquén": { lat: -38.9516, lon: -68.0591 },
    "Río Negro": { lat: -41.1342, lon: -71.3082 },
    "Salta": { lat: -24.7821, lon: -65.4232 },
    "San Juan": { lat: -31.5375, lon: -68.5364 },
    "San Luis": { lat: -33.3012, lon: -66.3378 },
    "Santa Cruz": { lat: -51.6231, lon: -69.2168 },
    "Santa Fe": { lat: -31.6234, lon: -60.7005 },
    "Santiago del Estero": { lat: -27.7844, lon: -64.2642 },
    "Tierra del Fuego, Antártida e Isla del Atlántico Sur": { lat: -54.8019, lon: -68.3030 },
    "Tucumán": { lat: -26.8083, lon: -65.2176 }
};

export default jurisdictionCoordinates;